export enum INTERVENTIONS_STATUS {
    DONE = "DONE",
    MISSED = "MISSED",
    SCHEDULED = "SCHEDULED",
    DELETED = "DELETED"
}

export interface IInterventionsLineItem {
    interventionId: number,
    originalInterventionText: string,
    modifiedInterventionText: string,
    interventionCategory: string
}

export interface IDateRangeList {
    fromDateEpoch: number;
    toDateEpoch: number;
}

export interface ICategoryProgressList {
    interventionCategory: string;
    totalInterventions: number;
    completedInterventions: number
}

export interface IFetchScheduledInterventionsProgressRequest {
    dateRangeList: Array<IDateRangeList>;
}

export interface IFetchScheduledInterventionsRequest {
    patientId: number;
    dateRange: IDateRangeList;
}


export interface IFetchScheduledInterventionsProgresssResponse {
    patientId: number;
    totalInterventions: number;
    completedInterventions: number;
    categoryProgressList: Array<ICategoryProgressList>;
    dateRange: IDateRangeList;
}


export interface IFetchScheduledInterventionsResponse {
    scheduledPlanItemId: string;
    patientId: number;
    status: INTERVENTIONS_STATUS;
    date: number;
    sourceReferenceId: number;
    scheduledPlanCategory: string;
    lineItem: IInterventionsLineItem;
}

